export class LogoutViewModel {
  public loggedOut = false;
}
